(() => {
  if (window.__HARDRIP_LUXURY_INTERACTIONS_V179__) return;
  window.__HARDRIP_LUXURY_INTERACTIONS_V179__ = !0;
  const SEARCH_CLOSE_MS = 220,
    NEW_DROP_DELAY_MS = 95;
  function restartClass(element, className) {
    element instanceof HTMLElement &&
      (element.classList.remove(className),
      element.offsetWidth,
      element.classList.add(className));
  }
  function clearOldInteractionState() {
    document
      .querySelectorAll(
        ".hardrip-luxury-press-v178, .hardrip-cart-icon-pop-v178",
      )
      .forEach((element) => {
        element.classList.remove(
          "hardrip-luxury-press-v178",
          "hardrip-cart-icon-pop-v178",
        );
      });
  }
  function closeSearch(details) {
    if (
      !(details instanceof HTMLDetailsElement) ||
      !details.open ||
      details.classList.contains("hardrip-search-closing-v179")
    )
      return;
    const host = details.closest(".header__search");
    (details.classList.add("hardrip-search-closing-v179"),
      host?.classList.add("hardrip-search-closing-v179"),
      window.setTimeout(() => {
        (details.removeAttribute("open"),
          details.classList.remove("hardrip-search-closing-v179"),
          host?.classList.remove("hardrip-search-closing-v179"));
      }, SEARCH_CLOSE_MS));
  }
  function bindSearch() {
    (document.querySelectorAll(".header__search details").forEach((details) => {
      details.addEventListener("toggle", () => {
        const host = details.closest(".header__search");
        (host?.classList.toggle("hardrip-search-open-v179", details.open),
          details.open ||
            (details.classList.remove("hardrip-search-closing-v179"),
            host?.classList.remove("hardrip-search-closing-v179")));
      });
    }),
      document.addEventListener(
        "click",
        (event) => {
          const summary = event.target.closest?.(
            ".header__search details > summary",
          );
          if (summary) {
            const details2 = summary.closest("details");
            details2?.open &&
              (event.preventDefault(),
              event.stopImmediatePropagation(),
              closeSearch(details2));
            return;
          }
          const closeTarget = event.target.closest?.(
            ".header__search .search-modal__close-button, .header__search .modal-overlay",
          );
          if (!closeTarget) return;
          const details = closeTarget
            .closest(".header__search")
            ?.querySelector("details[open]");
          details &&
            (event.preventDefault(),
            event.stopImmediatePropagation(),
            closeSearch(details));
        },
        !0,
      ),
      document.addEventListener(
        "keydown",
        (event) => {
          if (event.key !== "Escape") return;
          const details = document.querySelector(
            ".header__search details[open]",
          );
          details &&
            (event.preventDefault(),
            event.stopImmediatePropagation(),
            closeSearch(details));
        },
        !0,
      ));
  }
  function bindCart() {
    (document.addEventListener(
      "click",
      (event) => {
        const trigger = event.target.closest?.(
          '#cart-icon-bubble, .header__icon--cart, a[href="/cart"].header__icon',
        );
        trigger && restartClass(trigger, "hardrip-cart-icon-pop-v179");
      },
      !0,
    ),
      document.addEventListener(
        "animationend",
        (event) => {
          if (!(event.target instanceof HTMLElement)) return;
          if (
            event.target.closest?.(
              ".Avada-Faqs_Popup, #Avada-FAQ_WidgetTrigger",
            )
          )
            return;
          if (event.target.classList.contains("hardrip-cart-icon-pop-v179")) {
            event.target.classList.remove("hardrip-cart-icon-pop-v179");
          }
        },
        !0,
      ));
  }
  function findNewDropRoot(link) {
    let current = link;
    for (let depth = 0; current && depth < 7; depth += 1) {
      const text = (current.textContent || "").toUpperCase();
      if (text.includes("NEW DROP") && text.includes("SCOPRI LE NOVIT"))
        return current;
      current = current.parentElement;
    }
    return (
      link.closest(
        ".banner__box, .banner__content, .image-banner, .slideshow__text-wrapper",
      ) || link.parentElement
    );
  }
  function bindNewDrop() {
    const link = document.querySelector(
      'a[href="/collections/new-drop"], a[href^="/collections/new-drop?"], a[href*="/collections/new-drop"]',
    );
    if (!(link instanceof HTMLAnchorElement)) return;
    link.classList.add("hardrip-new-drop-link-v179");
    const root = findNewDropRoot(link);
    root?.classList.add("hardrip-new-drop-hitarea-v179");
    let navigating = !1;
    const navigate = (event) => {
      if (
        navigating ||
        event.button > 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      )
        return;
      const interactive = event.target.closest?.(
        "a, button, input, select, textarea",
      );
      (interactive && interactive !== link && !link.contains(interactive)) ||
        ((navigating = !0),
        event.preventDefault(),
        event.stopImmediatePropagation(),
        restartClass(root || link, "hardrip-new-drop-press-v179"),
        window.setTimeout(() => {
          window.location.assign(link.href);
        }, NEW_DROP_DELAY_MS));
    };
    (link.addEventListener("click", navigate, !0),
      root && root !== link && root.addEventListener("click", navigate, !0));
  }
  function init() {
    (clearOldInteractionState(), bindSearch(), bindCart(), bindNewDrop());
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init, { once: !0 })
    : init();
})();
//# sourceMappingURL=/cdn/shop/t/49/assets/hardrip-luxury-interactions-v17-9.js.map?v=117064912489735366351786517460
